const StreamIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24" height="24" viewBox="0 0 24 24"
		fill="currentColor"
		stroke="none"
		{...props}
	>
		<path d="M11 8V5H7V3H17V5H13V8H11ZM4 21V13H6V14H9V11H8V9H16V11H15V14H18V13H20V21H18V20H6V21H4Z" />
	</svg>
)

export default StreamIcon